import { genericService } from "./genericService";

const section = "TypeTrip";

function filter(name = " ", from = "0", limit = "10", active = "1") {
  return genericService.filter(section, "types", name, from, limit, active);
}

function getAll() {
  return genericService.get("TypeTrip/ListAllTypeTrip");
}

function remove(id) {
  return genericService.remove(section, id);
}

function create(item) {
  const param = {
    Type: item.typeTrip,
  };
  return genericService.create(section, param);
}

function update(item) {
  const param = {
    id: item.id,
    Type: item.typeTrip,
    isActive: item.isActive,
  };
  return genericService.update(section, param);
}

export const typeTripService = {
  getAll,
  filter,
  remove,
  create,
  update,
};
